module.exports = __webpack_public_path__ + "static/media/img7.4bb21634.png";